var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 503,
    viewBox: "0 0 503 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 0.477051,
    width: 355,
    height: 355,
    rx: 27,
    transform: "rotate(45 251.5 0.477051)",
    fill: "#F71480"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.001 211.8V259.708C247.001 270.999 243.947 279.621 237.837 285.576C231.728 291.453 223.067 294.392 211.853 294.392C206.285 294.392 201.297 293.58 196.889 291.956C192.559 290.332 189.001 288.051 186.217 285.112C183.356 288.051 179.76 290.332 175.429 291.956C171.099 293.58 166.188 294.392 160.697 294.392C149.484 294.392 140.823 291.453 134.713 285.576C128.604 279.621 125.549 270.999 125.549 259.708V211.8H144.341V259.128C144.341 265.701 145.695 270.573 148.401 273.744C151.108 276.837 155.129 278.384 160.465 278.384C171.369 278.384 176.821 271.965 176.821 259.128V211.8H195.613V259.128C195.613 271.965 201.104 278.384 212.085 278.384C222.757 278.384 228.093 271.965 228.093 259.128V211.8H247.001ZM293.421 226.88V277.92H307.457V293H260.477V277.92H274.629V226.88H260.477V211.8H307.457V226.88H293.421ZM380.815 234.536C373.855 230.515 366.393 227.924 358.427 226.764V293H339.635V226.764C331.67 227.924 324.169 230.515 317.131 234.536L310.751 220.5C316.319 217.175 322.351 214.661 328.847 212.96C335.343 211.259 342.033 210.408 348.915 210.408C355.875 210.408 362.603 211.259 369.099 212.96C375.673 214.661 381.705 217.175 387.195 220.5L380.815 234.536Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWit);
export default __webpack_public_path__ + "static/media/wit.d34b88acb48be23da56bac93ca9e261b.svg";
export { ForwardRef as ReactComponent };